import { Component, OnInit, Output, EventEmitter, Input, Renderer2, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
// import { UtilityService } from 'src/app/services/utility.service';
// import { config } from 'src/app/config';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from 'src/app/shared/utils/utility.service';
declare var Android;
@Component({
  selector: 'app-video-response',
  templateUrl: './video-response.component.html',
  styleUrls: ['./video-response.component.css']
})
export class VideoResponseComponent implements OnInit, OnDestroy {

  @ViewChild('myInputMobile')
  myInputMobileVar: ElementRef;
  @ViewChild('myInputDesktop')
  myInputDesktopVar: ElementRef;

  @Output() responseUrl = new EventEmitter<String>();
  @Output() recordingStarted = new EventEmitter<Boolean>(false);
  @Input() isSubmitted: boolean = false;
  @Input() set url(val: string) {
    this.source = val;
  }
  @Input()
  set stopCameraTag(value) {
    if (value && value.stop) {
      if (this.cameraTagStop) {
        this.cameraTagStop();
      }
    }
  }
  @ViewChild('cameraTagIFrame') cameraTagIFrame: HTMLIFrameElement;
  @Input() recorderId: string;
  @Input() questionUrl: any;
  @Input() playerindex:any;
  showProgress: boolean = false;
  showRecorder: boolean = false;
  fileList: any = [];
  invalidFileList: any = [];
  showDeleteModal: boolean = false;
  extension: string
  source: any = null;
  progress: number = 0;
  deviceInfo;
  fileSizeExceeded: boolean = false;
  disabled: boolean = false;
  fileShowProgress:boolean = false;
  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if (e.data.for == this.recorderId) {
      this.source = e.data.data;
      this.responseUrl.emit(this.source);
      this.recordingStarted.emit(false);
      this.showRecorder = false;
    }
  }
  isAndroidApp = false;
  constructor(private utitlityService: UtilityService, private renderer: Renderer2, private ref: ChangeDetectorRef, public deviceService: DeviceDetectorService, private toaster: ToastrService) { }

  ngOnInit() {
    this.isAndroidApp = /android/i.test(navigator.userAgent) && /wv/i.test(navigator.userAgent);
    this.epicFunction();
  }

  onFilesChange(fileList: Array<File>) {
    this.fileList = fileList;
    if (fileList[0].size > 104857600) {
      this.fileSizeExceeded = true;
      this.myInputMobileVar.nativeElement.value = "";
      this.myInputDesktopVar.nativeElement.value = "";
      this.toaster.warning("File size is more than 100 MB", "Upload failed:");
      return;
    }
    if (this.fileList.length == 1 && this.fileList[0].size < 104857600) {
      this.showProgress = true;
      const file = this.fileList[0];
      this.extension = file.name.split('.')[file.name.split('.').length - 1];
      if (this.extension == 'avi' || this.extension == 'wmv' || this.extension == 'flv' || this.extension == 'ogv' ) {
        this.showProgress = false;
        this.toaster.warning("File type not supported. Please upload an MP4 or MOV file.", "Upload Failed: ");
        return;
      }
      this.fileShowProgress = true; // file being uploaded
      let formData = new FormData();
      formData.append('resources', file);
      this.recordingStarted.emit(true);
      this.utitlityService.uploadFile(formData).subscribe(url => {
        this.responseUrl.emit(url);
        this.recordingStarted.emit(false);
        this.progress = 100;
        this.fileShowProgress = false; // file uploaded
        this.source = url;
      },(error) => {
        this.fileShowProgress = false; // file error
      });
      // ;
    } else {
      // this.fileSizeExceeded = true;
      this.toaster.warning("File size is more than 100 MB", "Upload failed:");
      // ;
    }
  }

  filesInvalidEmiter(fileList: Array<File>) {
    this.invalidFileList = fileList;
  }

  hide() {
    this.showDeleteModal = false;
  }
  delete() {
    this.fileList = [];
    this.source = null;
    this.progress = 0;
    this.responseUrl.emit('');
    this.hide();
    this.fileSizeExceeded = true;
  }
  show() {
    this.showDeleteModal = true;
  }

  runR() {
    if(this.isAndroidApp) {
      Android.recordFile('video');
      return;
    }
    this.showRecorder = true;
  }


  ngOnDestroy() {
  }

  load() {
    //  alert('allScriptLoaded');
    this.recordingStarted.emit(true);
  }

  reset() {
    this.fileList = [];
    this.source = null;
    this.progress = 0;
    this.recordingStarted.emit(false);
    this.showRecorder = false;
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    console.log(this.deviceInfo);
    console.log(isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    console.log(isTablet);  // returns if the device us a tablet (iPad etc)
    console.log(isDesktopDevice); // returns if the app is running on a Desktop browser.
  }

  cameraTagStop() {
    if (this.cameraTagIFrame) {
      let src = this.cameraTagIFrame.src;
      this.cameraTagIFrame.src = src;
    }
  }

  sendRecordFilePathForVideo(){
    let filePath = localStorage.getItem('fileStr');
  if(filePath && filePath.trim() != '') {
    localStorage.removeItem('fileStr');
    this.responseUrl.emit(filePath);
    this.recordingStarted.emit(false);
    this.progress = 100;
    this.source = filePath;
  }
}
}
